import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { ConfirmationModalComponent } from "@components/confirmation-modal/confirmation-modal.component";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ToolSet } from "@app/tool/model/toolSet.model";
import { Tool } from "@app/tool/model/tool.model";
import { ToolReturn } from "@app/shared/models/tool-return.model";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { ToolReturnsService } from "@app/core/services/tool-returns.service";
import { TranslateService } from "@ngx-translate/core";
import { Log } from "ng2-logger";
import { Location } from "@angular/common";
import { ToolService } from '@services/tool.service';
import { ToolPosition } from '@app/tool/model/tool-position.model';
import { ToolPositionModalComponent } from '@app/shared/components/tool-position-modal/tool-position-modal.component';
import { TrayType } from "@models/enums/tray-type.enum";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ResolutionService } from "@services/resolution.service";
import { LogoutModalComponent } from "@app/shared/components";

@UntilDestroy()
@Component({
    selector: 'app-incoming-tools-returned-detail',
    templateUrl: './incoming-tools-returned-detail.component.html',
    styleUrls: ['./incoming-tools-returned-detail.component.scss']
})
export class IncomingToolsReturnedDetailComponent implements OnInit {
    _logger = Log.create(IncomingToolsReturnedDetailComponent.name);

    @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;
    @ViewChild(ToolPositionModalComponent, {static: true}) positionModalComponent: ToolPositionModalComponent;
    @ViewChild('errorModal', {static: true}) errorModal: ConfirmationModalComponent;
    @ViewChild(LogoutModalComponent, {static: false}) logoutModal: LogoutModalComponent;

    selectedToolReturn: ToolReturn = new ToolReturn();
    selectedTools: Array<Tool | ToolSet> = [];
    selectedToolPositions: ToolPosition[] = [];
    selectedTool: Tool = null;
    tableConfig = new TableConfig();
    isConfirmationInProgress = false;

    isLoading = false;

    type: string;
    confirmationPopupMessage: string;

    @HostBinding('class.mobile') isMobile = false;

    constructor(private toolReturnsService: ToolReturnsService,
                private toolService: ToolService,
                private activatedRoute: ActivatedRoute,
                private toaster: ToastsManager,
                private router: Router,
                private translateService: TranslateService,
                private resolutionService: ResolutionService,
                private location: Location) {

        this.resolutionService.screenSize$.pipe(untilDestroyed(this)).subscribe(screen => {
            this.isMobile = screen.mobile;
        })
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            const id = +params['id'];
            this.getToolReturn(id);
        });
        this.activatedRoute.data.subscribe(value => {
            this.type = value['type'];
        })
    }


    onProcessToolReturn() {
        if (this.selectedToolReturn) {
            this._logger.info('onProcessToolReturn:: Processing tool return');
            this.confirmationModal.open();
        }
    }

    onBack() {
        this.location.back();
    }

    onConfirmProcess(event) {
        if (this.isConfirmationInProgress) {
            return;
        }
        this._logger.info('onConfirmProcess:: Closing tool return', event);
        this.isConfirmationInProgress = true;
        const boschId = this.isMobile ? null : event.boschId;
        this.toolReturnsService.closeToolReturnById(this.selectedToolReturn.id, boschId).subscribe(
            data => {
                this.confirmationModal.close();
                this.isConfirmationInProgress = false;
                this._logger.info('onConfirmProcess:: API returned data', data);
                this.toaster.success(this.buildProcessMessage(this.selectedToolReturn.toolRequest.name));

                if (this.isMobile) {
                    this.logoutModal.open();
                } else {
                    this.navigateToRoot();
                }
            },
            error => {
                this.confirmationModal.close();
                if (error && error.error) {
                    this.confirmationPopupMessage = error.error.message;
                    this.errorModal.open();
                }
                this._logger.error('onConfirmProcess:: API returned error', error);
                this.isConfirmationInProgress = false;
            }
        );
    }

    onInvalidBadge(event) {
        this._logger.info('onInvalidBadge::', event);
    }

    buildProcessMessage(toolRequestName) {
        return this.translateService.instant('lift-operator.incoming-tools-returned.toasts.processed',
            {toolRequestName: toolRequestName});
    }

    onLeafIconClick(node: Tool) {
        this.selectedTool = node;
        this.toolService.getToolLiftPositions(node.id, TrayType.Normal)
            .subscribe(data => {
                this.selectedToolPositions = data;
                this.positionModalComponent.open();
            });
    }

    onAssignToolPosition(event: any) {
        this.toolReturnsService
            .assignToolToSlot(this.selectedToolReturn.id, event.tool.id, event.position)
            .subscribe(data => {
                    this.getToolReturn(data as any);
                    this.positionModalComponent.close();
                    this.toaster.success(this.translateService.instant('admin.lifts.notifications.assignToolSuccess', {
                        tool: this.selectedTool.name,
                        position: event.position && event.position.slot ? event.position.slot.label : 'N/A'
                    }));
                    this.selectedTool = null;
                },
                error => {
                    this._logger.error('onAssignToolPosition:: API returned error', error);
                });
    }

    private navigateToRoot() {
        this.router.navigate(['/incoming-tools-returned/' + this.type]).then();
    }

    private getToolReturn(id: number) {
        this.isLoading = true;
        this.toolReturnsService.getToolReturn(id).subscribe(
            toolRequest => {
                this.selectedToolReturn = toolRequest;
                this.selectedTools = this.selectedToolReturn.returnTools;
                this.isLoading = false;
            }
        );
    }

    onContinue() {
        this.navigateToRoot();
    }
}
